import { setup } from 'axios-cache-adapter'
import localforage from 'localforage'
import memoryDriver from 'localforage-memoryStorageDriver'
import { apiPath, env } from 'utils'

// async wrapper to configure localforage and instantiate axios with axios-cache-adapter

export async function configure () {
  if (env === 'production') {
    console.log('production cache')
    // Register the custom memoryDriver to localforage
    await localforage.defineDriver(memoryDriver)

    // Create localforage instance
    const store = localforage.createInstance({
    // List of drivers used
      driver: [
        localforage.INDEXEDDB,
        localforage.LOCALSTORAGE,
        memoryDriver._driver
      ],
      // Prefix all storage keys to prevent conflicts
      name: 'rxCache'
    })

    // Create axios instance with pre-configured axios-cache-adapter using a localforage store
    return setup({
    // axios options
      baseURL: apiPath,
      // axios-cache-adapter options
      cache: {
        maxAge: 24 * 60 * 60 * 1000,
        store, // Pass localforage store to axios-cache-adapter
        clearOnStale: true,
        clearOnError: true,
        debug: false,
        exclude: {
        // {Array} List of regular expressions to match against request URLs.
          paths: [],
          // {Boolean} Exclude requests with query parameters.
          query: false,
          // {Function} Method which returns a Boolean to determine if request should be excluded from cache.
          filter: null
        }
      }
    })
  } else {
    console.log('staging cache')
    return setup({
    // axios options
      baseURL: apiPath,
      // axios-cache-adapter options
      cache: {
        maxAge: 24 * 60 * 60 * 1000,
        clearOnStale: true,
        clearOnError: true,
        debug: false,
        exclude: {
        // {Array} List of regular expressions to match against request URLs.
          paths: [],
          // {Boolean} Exclude requests with query parameters.
          query: false,
          // {Function} Method which returns a Boolean to determine if request should be excluded from cache.
          filter: null
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/CacheAdaptor.js